import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Event as SellerEvent } from 'src/app/models/core/event.model';

/** Lo que la fila usa de un evento (lo cumplen el del vendedor y el de molinetes). */
export type EventRowData = Pick<SellerEvent, 'name' | 'cover_image' | 'has_direct_sale_products'> & {
  initial_date: SellerEvent['initial_date'] | string;
};

export const EVENT_ROW_FALLBACK_IMAGE = 'assets/images/default-image.png';

@Component({
  selector: 'app-event-row-seller',
  templateUrl: './event-row-seller.component.html',
  styleUrls: ['./event-row-seller.component.scss'],
  standalone: false,
})
export class EventRowSellerComponent {
  @Input() event!: EventRowData;
  /** Texto opcional después de la fecha (p. ej. el lugar en Molinetes). */
  @Input() caption: string | null = null;
  /** Pastilla de acción: por defecto la del vendedor ("Vender"). */
  @Input() actionLabelKey = 'toolbar.sell';
  @Input() actionIcon = 'ticket-outline';
  /** Muestra la pastilla aunque el evento no tenga venta directa (Jefe/Admin: "Reporte"). */
  @Input() alwaysShowAction = false;
  /** Oculta la pastilla de acción (la fila solo navega al tocarla). */
  @Input() hideAction = false;
  /** Oculta la fecha: la fila la reemplaza por lo proyectado en `[rowEnd]`, a la derecha de la fila (p. ej. ventas). */
  @Input() hideDate = false;
  /** Nombre más chico y sin negrita (Multi-evento, donde las ventas son lo principal). */
  @Input() plainName = false;
  /** El nombre largo pasa a una segunda línea en vez de cortarse con "…". */
  @Input() wrapName = false;
  @Output() clickEvent = new EventEmitter<void>();
  @Output() sellClick = new EventEmitter<void>();

  imageError = false;

  get thumbSrc(): string {
    return this.imageError || !this.event.cover_image ? EVENT_ROW_FALLBACK_IMAGE : this.event.cover_image;
  }

  onImageError(): void {
    this.imageError = true;
  }

  onRowClick(): void {
    this.clickEvent.emit();
  }

  onSellClick(clickEvent: MouseEvent): void {
    clickEvent.stopPropagation();
    this.sellClick.emit();
  }
}
